import { createSlice } from '@reduxjs/toolkit'

import {
  parseAgencyAchievments,
  parseAgencyStatus,
  parseBenefitsLinks,
} from 'apps/agency/model/adapter'
import { AGENCY_LEVELS } from 'apps/agency/model/constants'
import type { AgencyLevel } from 'apps/agency/model/types'

import { getAchievements, getBenefitsLinks, getStatus } from './thunks'

interface AgencyStatusState {
  currentStatus: AgencyLevel | null
  achievements: ReturnType<typeof parseAgencyAchievments> | null
  benefitsLinks: ReturnType<typeof parseBenefitsLinks> | null
}

export const initialState: AgencyStatusState = {
  currentStatus: AGENCY_LEVELS.applicant,
  achievements: null,
  benefitsLinks: null,
}

const statusSlice = createSlice({
  name: 'agency/status',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatus.fulfilled, (state, action) => {
        state.currentStatus = parseAgencyStatus(action.payload) ?? null
      })
      .addCase(getAchievements.fulfilled, (state, action) => {
        state.achievements = parseAgencyAchievments(action.payload)
      })
      .addCase(getBenefitsLinks.fulfilled, (state, action) => {
        state.benefitsLinks = parseBenefitsLinks(action.payload)
      })
  },
})

export default statusSlice.reducer
